import { includeTextStyles, getColor } from '../../../legacylib/theme/utils';

import styled from 'styled-components';

export const Anchor = styled.a`
  ${includeTextStyles('body')};
  color: ${getColor('teal600')};
`;
